import axios from 'axios';
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux';
import { setLogin } from '../../redux/authSlice';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { Helmet } from 'react-helmet';

function LoginPage() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authForm = useForm();

    const [signinLoading, setSigninLoading] = useState(false);

    const signIn = (data) => {
        setSigninLoading(true);
        axios.post(`${process.env.REACT_APP_SERVICE_URL}/auth/authenticate`, {
            username: data.username,
            password: data.password
        })
            .then(response => {
                console.log(response.data)
                dispatch(
                    setLogin({
                        user: response.data.username,
                        token: response.data.token,
                        role: response.data.role,
                        companyId: response.data.companyId
                    })
                );
                navigate('/requests')
            })
            .catch(error => {
                console.log(error)
                dispatch(setLogin({
                    user: null,
                    token: null
                }))
                swal(
                    "Hata",
                    "Kullanıcı adı veya parola hatalı",
                    "error"
                )
            })
            .finally(() => {
                authForm.reset();
                setSigninLoading(false);
            })
    }

    return (
        <div className='bg-light min-vh-100 d-flex align-items-center justify-content-center py-4'>
            <Helmet>
                <title>Giriş Yap</title>
                <meta name='description' content='Giriş yap' />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>
            <div className='container-fluid'>
                <div className='row justify-content-center'>
                    <div className='col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3'>
                        <div className='card shadow border-0'>
                            <div className='card-header bg-white border-bottom py-3'>
                                <h5 className='card-title mb-0 text-center fw-bold'>Giriş Yap</h5>
                            </div>
                            <div className='card-body p-4'>
                                <form onSubmit={authForm.handleSubmit(signIn)}>
                                    {
                                        authForm.formState.errors.invalid && (
                                            <div className='alert alert-danger py-2 mb-3 d-flex align-items-center'>
                                                <i className='bi bi-exclamation-triangle-fill me-2'></i>
                                                <small className='mb-0'>{authForm.formState.errors.invalid.message}</small>
                                            </div>
                                        )
                                    }
                                    <div className='mb-3'>
                                        <label htmlFor='username' className='form-label mb-2 fw-semibold'>
                                            Kullanıcı Adı
                                        </label>
                                        <input 
                                            id='username'
                                            type='text' 
                                            className={`form-control ${authForm.formState.errors.username ? 'is-invalid' : ''}`}
                                            placeholder='Kullanıcı adınızı giriniz'
                                            autoComplete='username'
                                            autoFocus
                                            {...authForm.register('username', {
                                                required: "Kullanıcı adı zorunludur"
                                            })} 
                                        />
                                        {
                                            authForm.formState.errors.username && (
                                                <div className='invalid-feedback d-block'>
                                                    {authForm.formState.errors.username.message}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='mb-4'>
                                        <label htmlFor='password' className='form-label mb-2 fw-semibold'>Parola</label>
                                        <input 
                                            id='password'
                                            type='password' 
                                            className={`form-control ${authForm.formState.errors.password ? 'is-invalid' : ''}`}
                                            placeholder='Parolanızı giriniz'
                                            autoComplete='current-password'
                                            {...authForm.register('password', {
                                                required: "Parola zorunludur"
                                            })} 
                                        />
                                        {
                                            authForm.formState.errors.password && (
                                                <div className='invalid-feedback d-block'>
                                                    {authForm.formState.errors.password.message}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='d-grid'>
                                        <button 
                                            type='submit' 
                                            className='btn btn-dark btn-app btn-app--block' 
                                            disabled={signinLoading}
                                        >
                                            {signinLoading ? (
                                                <>
                                                    <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                                                    Giriş yapılıyor...
                                                </>
                                            ) : (
                                                'Giriş Yap'
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage